import { render, staticRenderFns } from "./shop-results.vue?vue&type=template&id=19eedbad&"
import script from "./shop-results.vue?vue&type=script&lang=js&"
export * from "./shop-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports